export const ProjectBadgeStatusType = {
  UNSUBMITTED: 'UNSUBMITTED',
  SUBMITTED: 'SUBMITTED',
  AWARDED: 'AWARDED',
  REJECTED: 'REJECTED',
  RESUBMITTED: 'RESUBMITTED',
};

export const projectBadgeStatusTypes = [
  ProjectBadgeStatusType.UNSUBMITTED,
  ProjectBadgeStatusType.SUBMITTED,
  ProjectBadgeStatusType.AWARDED,
  ProjectBadgeStatusType.REJECTED,
  ProjectBadgeStatusType.RESUBMITTED,
];
